// @ts-ignore
import fastclick from 'fastclick';
// @ts-ignore
import UAParser from 'ua-parser-js';
import devInit from './common';

const { eruda } = window as any;

export const ua = UAParser();

function checkMobile(): boolean {
  const userAgentInfo = navigator.userAgent.toLowerCase();

  const mobileAgents = [
    'android',
    'iphone',
    'symbianOS',
    'windows phone',
    'ipod',
    'mobile',
    'nokia',
    'samsung',
    'htc',
    'blackberry',
    // 判断微信
    'micromessenger',
  ];

  let mobileFlag = false;

  // 根据userAgent判断是否是手机
  // 根据userAgent判断是否是手机
  for (let v = 0; v < mobileAgents.length; v++) {
    if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
      mobileFlag = true;
      break;
    }
  }

  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  // 根据屏幕分辨率判断是否是手机
  if (screenWidth < 500 && screenHeight < 800) {
    mobileFlag = true;
  }

  return mobileFlag;
}

window.isPad = false;
window.isMobile = false;
window.isWeb = false;
window.isPC = false;
window.isAndroidApp = false;
window.isiOSApp = false;

// iOS13以前 navigator.platform 返回"iPhone"或"iPad"；iOS13以后的iPad，navigator.platform返回"MacIntel"，相当于Mac，由于目前还没有触摸屏的Mac，所以可以通过最大触控点来区分Mac和iPad的

if (
  ua.device.model === 'iPad' ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
  (ua.browser.name?.indexOf('Safari') !== -1 &&
    ua.device.model !== 'iPhone' &&
    'ontouchend' in document)
) {
  window.isPad = true;
  document.body.setAttribute('id', 'is-pad');
} else if (/Android.*popoversion/i.test(window.navigator.userAgent)) {
  window.isAndroidApp = true;
  window.isMobile = true;
  document.body.setAttribute('id', 'is-android-app');
} else if (/iPhone.*popoversion/i.test(window.navigator.userAgent)) {
  window.isiOSApp = true;
  window.isMobile = true;
  document.body.setAttribute('id', 'is-ios-app');
} else if (checkMobile()) {
  window.isMobile = true;
  document.body.setAttribute('id', 'is-mobile');
} else if (
  /POPOMeeting/.test(window.navigator.userAgent) ||
  /(popo)/i.test(window.navigator.userAgent)
) {
  window.isPC = true;
  document.body.setAttribute('id', 'is-pc');
} else {
  window.isWeb = true;
  document.body.setAttribute('id', 'is-web');
}

if (window.isPad || window.isMobile) {
  // (fastclick as any).attach(document.body);
  // window.addEventListener(
  //   'load',
  //   function () {
  //     (fastclick as any).attach(document.body);
  //   },
  //   false
  // );
  if (!location.pathname.includes('/pc/note')) {
    const metaP = document.createElement('div');
    metaP.innerHTML = `<meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0, minimum-scale=1.0,user-scalable=no, minimal-ui,viewport-fit=cover"><meta name="apple-mobile-web-app-capable" content="yes" />`;
    document.head.append(...metaP.children);
    window.addEventListener(
      'touchmove',
      (event) => {
        if (/iPhone/.test(window.navigator.userAgent) && (event as any).scale !== 1) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  } else {
    const metaP = document.createElement('div');
    metaP.innerHTML = `<meta name="viewport" content="width=device-width,initial-scale=1.0,minimal-ui,viewport-fit=cover"><meta name="apple-mobile-web-app-capable" content="yes" />`;
    document.head.append(...metaP.children);
  }
}

if (window.location.search.indexOf('devopen') !== -1) {
  sessionStorage.setItem('devOpen', 'true');
  eruda && eruda.init();
}
devInit('上上下左左下', () => {
  eruda && eruda.init();
});

if (
  window.location.hostname.includes('test-meet.popo.netease.com') &&
  window.location.pathname.includes('/pc/')
) {
  eruda && eruda.init();
}

if (process.env.UMI_ENV === 'dev' || process.env.UMI_ENV === 'test') {
  eruda && eruda.init();
}
